export const ProgressState = {
    Expired: 'Expired',
    Declined: 'Declined',
    Started: 'Started',
    OrrAccepted: 'OrrAccepted',
    BankStatementRequested: 'BankStatementRequested',
    BankStatementVerified: 'BankStatementVerified',
    BankStatementAnalysed: 'BankStatementAnalysed',
    CreditBureauAnalysed: 'CreditBureauAnalysed',
    EligibilityCalculated: 'EligibilityCalculated',
    LoanSummaryCalculated: 'LoanSummaryCalculated',
    MandateInitiated: 'MandateInitiated',
    MandateApproved: 'MandateApproved',
    Approved: 'Approved',
    PendingDisbursement: 'PendingDisbursement',
    Disbursed: 'Disbursed'
  };